import useShowModal, { ModalTypes } from "@actions/useShowModal";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { downloadFile } from "../../actions/actions";
import scheduleDemo from "../helpers/scheduleDemo";

export enum MarketingActions {
  DOWNLOAD_MAC_APP = "DOWNLOAD_MAC_APP",
  DOWNLOAD_MAC_APP_BETA = "DOWNLOAD_MAC_APP_BETA",
  BOOK_DEMO = "BOOK_DEMO",
  CONTACT_SALES = "CONTACT_SALES",
}

export const useMarketingActions = () => {
  const dispatch = useDispatch();
  const { showModal } = useShowModal();

  const downloadMacApp = useCallback(() => {
    dispatch(downloadFile("/download/macOS"));
  }, [dispatch]);

  const downloadBeta = useCallback(() => {
    dispatch(downloadFile("/download/macOS/beta"));
  }, [dispatch]);

  const bookDemo = useCallback(() => {
    scheduleDemo();
  }, []);

  const contactSales = useCallback(() => {
    showModal(ModalTypes.ENTERPRISE_REQUEST, {});
  }, [showModal]);

  return {
    [MarketingActions.DOWNLOAD_MAC_APP]: downloadMacApp,
    [MarketingActions.DOWNLOAD_MAC_APP_BETA]: downloadBeta,
    [MarketingActions.BOOK_DEMO]: bookDemo,
    [MarketingActions.CONTACT_SALES]: contactSales,
  };
};
